export default __webpack_public_path__ + "static/media/pp-dropdown.c2f28e3c.webp";